import React, { CSSProperties } from "react"
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui/Table"
import TableActionBar from "../../components/layout/TableActionBar"
import strings from "../../localization/strings"
import { green500 } from "material-ui/styles/colors"
import FloatingActionButton from "material-ui/FloatingActionButton"
import ContentAdd from "material-ui/svg-icons/content/add"
import AddPayTypeDialog from "./AddPayTypeDialog"
import autobind from "class-autobind"
import AppStateStore from "../../stores/AppStateStore"
import * as api from "../../api"
import { IPayType } from "../../models"
import _ from "lodash"
import AccountStore from "../../stores/AccountStore"
interface IExtendPayType extends IPayType {
    deleteValidation: boolean
}
interface IProps {
    accountId: string
    payTypes: IPayType[]
    addPayType(payType: IPayType, cb: Function): void
    updatePayType(editPayType: IPayType, cb: Function): void
    deletePayType(deletePayTypeId: string, cb: Function): void
}
interface IState {
    searchedPayTypes: IExtendPayType[]
    selectedIndex: number
    shouldRemovePayType: IExtendPayType
    searchText: string
    openAddPayTypeDialog: boolean
    editablePayType: IPayType
    selectedPayType: IPayType
    showTableActionBar: boolean
}

export default class PayTypes extends React.Component<IProps, IState>  {
    constructor(props: IProps) {
        super(props)
        this.state = {
            searchedPayTypes: [],
            selectedIndex: -1,
            shouldRemovePayType: null,
            searchText: "",
            openAddPayTypeDialog: false,
            editablePayType: null,
            selectedPayType: null,
            showTableActionBar: true
        }
        autobind(this)
    }

    componentDidMount() {
        this.setState({
            searchedPayTypes: this.props.payTypes as IExtendPayType[],
            selectedIndex: -1,
            shouldRemovePayType: null
        })
    }

    componentWillReceiveProps(nextProps) {
        !_.isEqual(this.props.payTypes, nextProps.payTypes) &&
            this.setState({
                searchedPayTypes: nextProps.payTypes.sort((a, b) => {
                    if (a.Name === b.Name) return 0
                    if (a.Name < b.Name) return -1
                    if (a.Name > b.Name) return 1
                }),
                selectedIndex: -1,
                shouldRemovePayType: null
            })
    }

    onTableCellClick(rowNumber, columnId) {
        if (columnId === -1) {
            let { selectedIndex } = this.state
            if (selectedIndex === rowNumber) {
                selectedIndex = -1
            } else {
                selectedIndex = rowNumber
            }

            this.setState(
                {
                    selectedIndex
                },
                () => {
                    if (this.state.selectedIndex === -1) {
                        this.setState({
                            shouldRemovePayType: null
                        })
                    } else {
                        const shouldRemovePayType = this.state.searchedPayTypes[selectedIndex]
                        const { accountId } = this.props
                        api.deleteValidationPayType(accountId, shouldRemovePayType.Id)
                            .then((response) => {
                                shouldRemovePayType.deleteValidation = response.data
                                this.setState({
                                    shouldRemovePayType
                                })
                            })
                            .catch((err) => {
                                shouldRemovePayType.deleteValidation = false
                                this.setState({
                                    shouldRemovePayType
                                })
                            })
                    }
                }
            )
        } else {
            this.setState({
                editablePayType: this.state.searchedPayTypes[rowNumber],
                openAddPayTypeDialog: true,
                selectedIndex: -1,
                shouldRemovePayType: null
            })
        }
    }

    openAddPayTypeDialog() {
        this.setState({
            openAddPayTypeDialog: true
        })
    }

    closeAddPayTypeDialog() {
        this.setState({
            openAddPayTypeDialog: false,
            editablePayType: null
        })
    }

    handlerPayTypeSave(add, payType) {
        this.reloadTableActionBar()
        this.closeAddPayTypeDialog()
        AppStateStore.setProgressSnackbarContent("loading")
        add ?
            this.props.addPayType(payType, () =>
                AppStateStore.setProgressSnackbarContent(strings.PayType_created_successfully)
            ) :
            this.props.updatePayType(payType, () =>
                AppStateStore.setProgressSnackbarContent(strings.PayType_updated_successfully)
            )
    }

    onSearch(searchText) {
        const { payTypes } = this.props
        const searchedPayTypes = payTypes.slice().filter((payType) => {
            return payType.Name.toLowerCase().indexOf(searchText.toLowerCase()) > -1
        }).sort((a, b) => {
            if (a.Name === b.Name) return 0
            if (a.Name < b.Name) return -1
            if (a.Name > b.Name) return 1
        })

        this.setState({
            searchedPayTypes: searchedPayTypes as IExtendPayType[],
            selectedIndex: -1,
            shouldRemovePayType: null
        })
    }

    handleDeleteDialog() {

    }

    reloadTableActionBar() {
        this.setState(
            {
                showTableActionBar: false
            },
            () => {
                this.setState({
                    showTableActionBar: true
                })
            }
        )
    }

    render() {
        const { payTypes } = this.props
        if (payTypes.length === 0) {
            return (
                <div style={styles.noPayType as CSSProperties}>
                    <span>{strings.There_is_no_pay_type}</span>
                </div>
            )
        }

        const { searchText, openAddPayTypeDialog, editablePayType, searchedPayTypes, selectedIndex, showTableActionBar } = this.state
        const trueIcon = (
            <div>
                <i style={{ fontSize: 22, color: green500 }} className="fa fa-check" />
            </div>
        )

        return (
            <div>
                <FloatingActionButton data-intercom-target={"menu-AccountSettings-PayConfiguration-PayTypesTab-Btn-Add"} className="fixed-add" style={{ top: -28, right: 20 }} secondary={true} onTouchTap={this.openAddPayTypeDialog}>
                    <ContentAdd />
                </FloatingActionButton>
                <div style={{ paddingTop: 30 }}>
                    {showTableActionBar && (
                        <TableActionBar
                            onSearch={this.onSearch.bind(this)}
                            searchText={searchText}
                            rowSelectionCount={selectedIndex === -1 ? 0 : 1}
                            singleSelectedMessage={strings.Pay_Type_Selected}
                            title={strings.Pay_Types}
                            titleStyle={{ fontSize: 16 }}
                            bodyStyle={{ padding: 20, fontWeight: 500 }}
                            onDeleteClick={() =>
                                this.state.shouldRemovePayType.deleteValidation ?
                                    AppStateStore.setConfirmDialogContent({
                                        title: strings.Delete_Pay_Type,
                                        content: strings.Are_you_sure_delete_pay_type,
                                        confirm: () => {
                                            AppStateStore.setProgressSnackbarContent("loading")
                                            this.props.deletePayType(this.state.shouldRemovePayType.Id, () =>
                                                AppStateStore.setProgressSnackbarContent(strings.PayType_removed_successfully)
                                            )
                                            this.reloadTableActionBar()
                                        }
                                    }) :
                                    AppStateStore.setProgressSnackbarContent(strings.You_cant_delete_pay_type)
                            }
                        />
                    )}
                    <div style={{ maxHeight: 250, overflowY: "auto" }}>
                        {searchedPayTypes.length === 0 ? (
                            <h2 style={{ textAlign: "center", marginTop: 25 }}>{strings.No_Pay_Type}</h2>
                        ) : (
                            <Table onCellClick={this.onTableCellClick}>
                                <TableHeader>
                                    <TableRow>
                                        <TableHeaderColumn style={styles.columnValue}>{strings.Pay_Type_Name}</TableHeaderColumn>
                                        <TableHeaderColumn style={styles.columnValue}>{strings.Pay_Type_Code}</TableHeaderColumn>
                                        <TableHeaderColumn style={styles.columnValue}>{strings.Paid_Time}</TableHeaderColumn>
                                        <TableHeaderColumn style={styles.columnValue}>{strings.Credit_Accrual}</TableHeaderColumn>
                                        <TableHeaderColumn style={styles.columnValue}>{strings.Use_Towards_Overtime}</TableHeaderColumn>
                                        <TableHeaderColumn style={styles.columnValue}>Non-Productive Time</TableHeaderColumn>
                                        <TableHeaderColumn style={styles.columnValue}>Exclude From Totals</TableHeaderColumn>
                                        {AccountStore.getMedicalAccount() && <TableHeaderColumn style={styles.columnValue}>Utilization Calc</TableHeaderColumn>}
                                    </TableRow>
                                </TableHeader>
                                <TableBody deselectOnClickaway={false}>
                                    {searchedPayTypes.map((payType, key) => (
                                        <TableRow data-intercom-target={key === 0 && "menu-AccountSettings-PayConfiguration-PayTypesTab-openItemDetails"} selected={selectedIndex === key} key={key}>
                                            <TableRowColumn style={styles.columnValue}>{payType.Name}</TableRowColumn>
                                            <TableRowColumn style={styles.columnValue}>{payType.Code}</TableRowColumn>
                                            <TableRowColumn style={styles.columnValue}>{payType.PaidTime && trueIcon}</TableRowColumn>
                                            <TableRowColumn style={styles.columnValue}>{payType.CreditAccrual && trueIcon}</TableRowColumn>
                                            <TableRowColumn style={styles.columnValue}>{payType.UseTowardsOvertime && trueIcon}</TableRowColumn>
                                            <TableRowColumn style={styles.columnValue}>{payType.NonProductiveTime && trueIcon}</TableRowColumn>
                                            <TableRowColumn style={styles.columnValue}>{payType.ExcludeFromTimeTotals && trueIcon}</TableRowColumn>
                                            {AccountStore.getMedicalAccount() && <TableRowColumn style={styles.columnValue}>{payType.UseTowardsUtilizationCalculation && trueIcon}</TableRowColumn>}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        )}
                    </div>
                </div>
                {openAddPayTypeDialog &&
                    <AddPayTypeDialog
                        onRequestClose={this.closeAddPayTypeDialog}
                        editablePayType={editablePayType}
                        handlerPayTypeSave={this.handlerPayTypeSave}
                        payTypes={payTypes}
                    />
                }
            </div>
        )
    }
}

const styles = {
    columnValue: {
        textAlign: "center",
        cursor: "pointer",
        whitespace: "normal"
    },
    noPayType: {
        textAlign: "center",
        fontSize: 25,
        paddingTop: 50,
        fontWeight: "bold"
    }
}
